// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "icon-3Na9D";
export { _1 as "__esModule", _2 as "icon" }
export default { "__esModule": _1, "icon": _2 }
